export default "__VITE_ASSET__DlaMxHNM__"